import { render, staticRenderFns } from "./CompanyRequests.vue?vue&type=template&id=1c01599a"
import script from "./CompanyRequests.vue?vue&type=script&lang=js"
export * from "./CompanyRequests.vue?vue&type=script&lang=js"
import style0 from "./CompanyRequests.vue?vue&type=style&index=0&id=1c01599a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports